/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rtl_Text_FixedInputs */

const en_rtl_text_fixed = /** @type {(inputs: Rtl_Text_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RTL text has been fixed.`)
};

const fr_rtl_text_fixed = /** @type {(inputs: Rtl_Text_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le texte RTL a été corrigé.`)
};

const de_rtl_text_fixed = /** @type {(inputs: Rtl_Text_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Problem mit RTL-Text wurde behoben.`)
};

const it_rtl_text_fixed = /** @type {(inputs: Rtl_Text_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il testo RTL è stato corretto.`)
};

const ru_rtl_text_fixed = /** @type {(inputs: Rtl_Text_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Исправлена ошибка в тексте, написанном справа налево.`)
};

const es_rtl_text_fixed = /** @type {(inputs: Rtl_Text_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se ha corregido el texto RTL.`)
};

const zh_cn2_rtl_text_fixed = /** @type {(inputs: Rtl_Text_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RTL文本已修复。`)
};

const ja_rtl_text_fixed = /** @type {(inputs: Rtl_Text_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RTLテキストが修正されました。`)
};

const hi_rtl_text_fixed = /** @type {(inputs: Rtl_Text_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आरटीएल टेक्स्ट की समस्या ठीक कर दी गई है।`)
};

const pt_pt2_rtl_text_fixed = /** @type {(inputs: Rtl_Text_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O texto da direita para a esquerda foi corrigido.`)
};

/**
* | output |
* | --- |
* | "RTL text has been fixed." |
*
* @param {Rtl_Text_FixedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const rtl_text_fixed = /** @type {((inputs?: Rtl_Text_FixedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rtl_Text_FixedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_rtl_text_fixed(inputs)
	if (locale === "de") return de_rtl_text_fixed(inputs)
	if (locale === "it") return it_rtl_text_fixed(inputs)
	if (locale === "ru") return ru_rtl_text_fixed(inputs)
	if (locale === "es") return es_rtl_text_fixed(inputs)
	if (locale === "zh-CN") return zh_cn2_rtl_text_fixed(inputs)
	if (locale === "ja") return ja_rtl_text_fixed(inputs)
	if (locale === "hi") return hi_rtl_text_fixed(inputs)
	if (locale === "pt-PT") return pt_pt2_rtl_text_fixed(inputs)
	return en_rtl_text_fixed(inputs)
});